import { zodResolver } from '@hookform/resolvers/zod'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import {
  FormInput,
  FormWrapper,
} from 'src/shared/components/FormComponents'
import { Column, Row } from 'src/shared/components/Semantic/all'
import { Button } from 'src/shared/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogHeader,
} from 'src/shared/components/ui/dialog'
import { useLocalization } from 'src/shared/hooks/useLocalization'
import { TeamMember, EditUserFormData } from '../types'

const formSchema = z.object({
  first_name: z.string().optional(),
  last_name: z.string().optional(),
  phone: z.string().optional(),
})

export const EditUserDialog = ({
  isOpen,
  onOpenChange,
  editingUser,
  onSave,
  isLoading,
}: {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  editingUser: TeamMember | null
  onSave: (data: EditUserFormData) => Promise<void>
  isLoading: boolean
}) => {
  const { t } = useLocalization()

  const methods = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      first_name: '',
      last_name: '',
      phone: '',
    },
  })

  useEffect(() => {
    if (editingUser) {
      methods.reset({
        first_name: editingUser.first_name || '',
        last_name: editingUser.last_name || '',
        phone: editingUser.phone || '',
      })
    } else {
      methods.reset({
        first_name: '',
        last_name: '',
        phone: '',
      })
    }
  }, [editingUser, methods])

  const handleSubmit = async (data: z.infer<typeof formSchema>) => {
    await onSave(data)
    onOpenChange(false)
  }

  const handleCancel = () => {
    methods.reset()
    onOpenChange(false)
  }

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <h1>{t('Edit user', 'Redigera användare')}</h1>
        </DialogHeader>

        <FormWrapper methods={methods} onSubmit={handleSubmit}>
          <Column className="gap-4 mt-4">
            <FormInput
              label={t('First name', 'Förnamn')}
              name="first_name"
              methods={methods}
              placeholder={t('First name', 'Förnamn')}
            />

            <FormInput
              label={t('Last name', 'Efternamn')}
              name="last_name"
              methods={methods}
              placeholder={t('Last name', 'Efternamn')}
            />

            <FormInput
              label={t('Phone', 'Telefon')}
              name="phone"
              methods={methods}
              placeholder={t('Phone', 'Telefon')}
            />
          </Column>

          <Row className="justify-end gap-2 mt-4">
            <Button type="button" variant="secondary" onClick={handleCancel}>
              {t('Cancel', 'Avbryt')}
            </Button>
            <Button type="submit" isLoading={isLoading}>
              {t('Save', 'Spara')}
            </Button>
          </Row>
        </FormWrapper>
      </DialogContent>
    </Dialog>
  )
}

